export const UPDATE_PROFILE_INFO = 1
export const UPDATE_REGISTRATION = 2
export const NONE = 3
